import React, { createContext, useReducer, useContext } from 'react';
import PropTypes from 'prop-types';

import Reducer from 'reducers/reducer';
import {
  MAP_LABEL_LOCATIONS,
  PROPERTY_MAP_FIELDS_OPTIONS
} from 'screens/Property/helpers/constants';
import { MAP_STYLE_TYPES } from 'helpers/constants';
import { RADIO_OPTIONS_FLAGS } from 'screens/Property/PropertiesLanding/components/PropertyTreeView/components/PropertyFilters/constants';

export const initialState = {
  toolbarComponents: null,
  error: null,
  organizations: null,
  organization: {
    id: "7b6ca193-5144-4835-a292-be30f744492b",
    name: 'Test Org'
  },
  permission: [],
  backgroundColor: '#F3F4F6',
  organizationPermissions: [], // an array of (organization,permission) tuples the user can access,
  selectedContext: null, // used to communicate selected context from the Breadcrumb to the active components
  planToConvert: {}, // used to pass plan details to tasks or recommendations
  weatherAutomaticToggle: true, // Toggle feature at global level to populate weather data when "ON"
  shouldResetPropertyName: false, // used to reflect changes of farm/field/cropzone names
  loggedInUserOrgPermission: { role: 'View Only', financialAccess: undefined },
  loadingOrg: true,
  selectedProperty: {},
  expandedPropertyIds: [],
  cropSeasons: [],
  selectedFieldRowId: {},
  // Mass Assigner
  isEnableInfoTabEdit: false,
  isMassAssignerActive: false,
  fieldsToMassiveAssign: [],
  massiveChangeSummary: {},
  isFarmEdited: false,
  updateCropName: { cropName: '', cropId: '', shouldUpdate: false },
  massAssignerSuccessCounter: {},
  massAssignerRejections: [],
  // Export PDF Maps
  isExportPDFMapsActive: false,
  isExportPDFMapsAlertDismissed: false,
  exportPDFMapsStep: 0,
  mapPrintableAreaBbox: null,
  propertyMapFieldsConfig: PROPERTY_MAP_FIELDS_OPTIONS.HIDE,
  cropColors: {},
  mapLabelConfig: {
    labelLocation: MAP_LABEL_LOCATIONS.MAP,
    farmNames: false,
    fieldNames: true,
    cropZoneNames: true,
    assignedCropType: false,
    area: false
  },
  mapLegendLabels: {},
  propertyMapFooterConfig: {
    organizationName: true,
    farmNames: true,
    cropSeasonNames: false
  },
  mapStyleImage: MAP_STYLE_TYPES.satellite,
  isSortByCrop: false,
  // FFT
  isGlobalCropSeasonLoading: false,
  searchTextValueFFT: '',
  isFieldImportedSuccessful: false,
  importedFields: [],
  loadingProperties: true,
  isMapMoving: false,
  loadTimestamp: new Date().valueOf(),
  isFullScreenNeeded: false,
  uploadedFiles: [],
  loadingCosts: true,
  selectedYieldCommodity: { id: '', name: '' },
  zoomInitialMap: false,
  cropZoneMatcherType: 'null',
  selectedProduct: undefined,
  showToastCropZoneMatcher: false,
  showToastPropertyRemove: false,
  showToastRemoveProduct: false,
  showToastChangesSaved: false,
  toastType: 'null',
  toastMessage: 'null',
  removeProductFailure: false,
  additionalInformationToastCropZoneMatcher: {
    cropZoneName: '',
    operationMapped: '',
    totalOperationMapped: ''
  },
  propertyFilters: {
    showArchivedProperties: false,
    showFarmWithIds: [],
    tasksFiltersConfig: {
      radioOption: RADIO_OPTIONS_FLAGS.anyTags,
      showTaskTagsWithIds: []
    }
  },
  isSidebarOpen: false,
  showToastSaleLocation: false,
  sortRules: undefined,
  selectedLocation: undefined,
  taskCreationFrom: undefined,
  cropSeasonCreationFrom: undefined,
  allFFTGeoJson: { features: [] }
};

const Store = ({ children = /** @type {React.ReactNode} */ (null) }) => {
  const [state, dispatch] = useReducer(Reducer, {
    ...initialState
  });

  return (
    <Context.Provider value={[state, dispatch]}>{children}</Context.Provider>
  );
};

export const useStore = () => {
  const context = useContext(Context);
  if (!context) {
    throw new Error('useStore must be used within a StoreProvider');
  }
  return { state: context[0], dispatch: context[1] };
};

Store.propTypes = {
  children: PropTypes.node
};

export const Context = createContext(initialState);
export default Store;
